import React from 'react'
import { Flex, Box } from 'reflexbox'
import SbEditable from 'storyblok-react'

import { parseStoryblokProductToAlgolia } from 'src/algolia/clienthelpers'
import { Container, Row, Column } from 'src/components/UI/Grid/Grid'
import ProductCard from 'src/components//ProductCard/ProductCard'
import Markdown from 'src/components/Markdown/Markdown'

import * as styles from './TextAndProduct.module.scss'
import { Props } from './types'

const TextAndProduct = ({ blok }: Props): JSX.Element => {
  const { text, product, product_position } = blok
  const productOnLeft = product_position === 'left'

  const parsedProduct = product ? parseStoryblokProductToAlgolia(product) : null
  return (
    <SbEditable content={blok}>
      <Flex
        className={styles.wrapper}
        flexDirection={['column', null, null, 'row']}
      >
        <Box
          order={[0, null, null, productOnLeft ? 1 : 0]}
          width={[1, null, null, 1 / 2]}
        >
          <Box className={styles.textWrapper}>
            <Flex
              className={styles.textContent}
              paddingX={[4, null, null, 20]}
              paddingY={[25, null, null, 0]}
              flexDirection="column"
              justifyContent="center"
            >
              {text && <Markdown source={text} />}
            </Flex>
          </Box>
        </Box>
        <Box
          order={[1, null, null, productOnLeft ? 0 : 1]}
          width={[1, null, null, 1 / 2]}
        >
          <Box className={styles.productWrapper}>
            <Flex
              className={styles.productContent}
              paddingY={[10, null, null, 0]}
              flexDirection="column"
              justifyContent="center"
              alignItems="center"
            >
              {parsedProduct && (
                <Box width={[3 / 6]}>
                  <Box className={styles.productCard} padding={[4]}>
                    <ProductCard {...parsedProduct} />
                  </Box>
                </Box>
              )}
            </Flex>
          </Box>
        </Box>
      </Flex>
    </SbEditable>
  )
}

export default TextAndProduct
